import React, { useState } from "react";
import { useDispatchApp, useSelectorApp } from "../../../lib/redux";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import StripePayForm from "../Stripe/StripePayForm";
import RadioGroupCards from "../Stripe/RadioGroupCards";
import { startPayInvoice } from "../../../actions/payments";
import ModalBasicLayout from "./ModalBasicLayout";
import { onInit3DSecureAuth } from "../../../services/stripe";
import { useStripe } from "@stripe/react-stripe-js";
import {
  MODAL_PAY_INVOICE_ARIA_LABEL,
  MODAL_PAY_INVOICE_TITLE,
  MODAL_PAY_INVOICE_WILL_PAY,
  PAY,
} from "../../../locales/keysTranslations";
import { useTranslationApp } from "../../../lib/i18next";
import { useLocale } from "../../../Contexts/LocaleContext";
import ContainerModalActions from "../Containers/ContainerModalActions";

const ModalPayInvoice = ({ modalOpen, onCloseModal, invoiceID, data }) => {
  const [card, setCard] = useState(0);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslationApp();

  const LOCALE = useLocale();

  const dispatch = useDispatchApp();
  const stripe = useStripe();

  const {
    defaultPaymentMethod: { id },
  } = useSelectorApp((state) => state.payments.stripe);

  const onPayInvoice = async (paymentMethodID = card, paymentIntent) => {
    setLoading(true);
    const response = await dispatch(
      startPayInvoice({
        invoiceID,
        paymentMethodID,
        paymentIntent,
      })
    );
    if (response.ok) {
      setLoading(false);
      onCloseModal();
      return { ok: true };
    }
    if (!response.ok && response.status === "requiresAction") {
      const responseVerification = await onInit3DSecureAuth({
        clientSecret: response.clientSecret,
        stripe,
        onCallbackFailed: onCloseModal,
      });
      setLoading(false);
      if (responseVerification.ok) {
        const paymentIntent = responseVerification.paymentIntent;
        await onPayInvoice(paymentMethodID, paymentIntent);
        return { ok: true };
      }
    }
    setLoading(false);
    return { ok: false };
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      ariaLabel={t(MODAL_PAY_INVOICE_ARIA_LABEL)}
      title={t(MODAL_PAY_INVOICE_TITLE, {
        value: invoiceID,
      })}
    >
      {id.length === 0 ? (
        <StripePayForm
          textButton={t(PAY)}
          onSubmit={(paymentMethod) => onPayInvoice(paymentMethod.id)}
          saveCard={false}
          setDefaultCard={false}
        />
      ) : (
        <RadioGroupCards
          onSelectCard={(paymentMethod) => setCard(paymentMethod)}
          onCallbackMakeDefaultPaymentMethod={onCloseModal}
          showMakeDefaultPaymentMethod={false}
        />
      )}
      <Typography variant="body1" align="center" sx={{ mt: 2 }}>
        {t(MODAL_PAY_INVOICE_WILL_PAY, {
          value: data.value,
          currency: data?.currency || LOCALE.currency,
        })}
      </Typography>
      {id.length > 0 && (
        <DialogActions sx={{ p: 0 }}>
          <ContainerModalActions
            propsPrimaryButton={{
              showButton: true,
              text: PAY,
              loading,
              onClick: () => onPayInvoice(),
              disabled: !card,
            }}
          />
        </DialogActions>
      )}
    </ModalBasicLayout>
  );
};

export default ModalPayInvoice;
